export const SUPERVISOR_ROLE = 'supervisor';

export const isSupervisorRole = role => role === SUPERVISOR_ROLE;

export const canAccessAllConversations = role =>
  ['administrator', 'agent', SUPERVISOR_ROLE].includes(role);

export const buildSupervisorRoleOption = translate => ({
  id: SUPERVISOR_ROLE,
  name: SUPERVISOR_ROLE,
  label: translate('AGENT_MGMT.AGENT_TYPES.SUPERVISOR'),
});

export const shouldAllowSupervisorRoute = ({
  role,
  permissions,
  featureFlag,
  account,
}) => {
  const featureStateUnavailable =
    featureFlag && (!account || !account.features);

  return (
    isSupervisorRole(role) &&
    Array.isArray(permissions) &&
    permissions.includes(SUPERVISOR_ROLE) &&
    featureStateUnavailable
  );
};
